import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AuthService } from 'src/app/modules/core/services/auth.service';

export const isLoggedInGuard: CanActivateFn = () => inject(AuthService).canActivate();